import React from "react";
import { Sidebar, Menu } from "react-pro-sidebar";
import {
  LuLayoutDashboard,
  LuSettings
} from "react-icons/lu";
import { BsArrowRightSquare, BsArrowLeftSquare } from "react-icons/bs";
import { GoGraph } from "react-icons/go";
import { PiGraph } from "react-icons/pi";
import { CgProfile } from "react-icons/cg";
import { SidebarItem } from "./SidebarItem";

export const ProSidebar = ({ collapsed, toggleCollapse }) => {
  return (
    <div className={`fixed top-0 left-0 h-full z-50 transition-all duration-300 ${collapsed ? "w-[80px]" : "w-[270px]"}`}>
      <Sidebar
        collapsed={collapsed}
        toggled={true}
        onToggle={toggleCollapse}
        backgroundColor="#FFFFFF"
        width={collapsed ? "80px" : "270px"}
        className="h-full !border-r-2 !border-gray-100"
      >
        <div className="flex flex-col h-full text-gray-800">
          <div className="p-4 flex items-center justify-center h-[80px] border-b border-gray-200">
            <img
              src="/img/logo.png"
              alt="AMPTRANS logo"
              className={`transition-all duration-300 ${collapsed ? "w-10" : "w-32"}`}
            />
          </div>
          
          <div className="flex-1 overflow-y-auto">
            <Menu
              menuItemStyles={{
                button: ({ level, active }) => {
                  return {
                    padding: '10px 20px',
                    borderRadius: '8px',
                    margin: '5px 10px',
                    backgroundColor: active ? '#eff6ff' : 'transparent',
                    color: active ? '#2563eb' : '#374151',
                    '&:hover': {
                      backgroundColor: '#f3f4f6',
                      color: '#1f2937',
                    },
                  };
                },
              }}
            >
              <div className="pt-4">
                <SidebarItem
                  collapsed={collapsed}
                  icon={<LuLayoutDashboard size={22} />}
                  text="Dashboard"
                  link="/fleet-planning-pro"
                />
              </div>

              <div>
                <p className={`text-xs uppercase font-semibold text-gray-500 py-2 ${collapsed ? 'text-center' : 'px-6'}`}>
                  {collapsed ? 'ADD' : 'Edit/Add'}
                </p>
                <SidebarItem
                  collapsed={collapsed}
                  icon={<PiGraph size={22} />}
                  text="Inputs"
                  link="/inputs"
                />
              </div>

              <div>
                <p className={`text-xs uppercase font-semibold text-gray-500 py-2 ${collapsed ? 'text-center' : 'px-6'}`}>
                  {collapsed ? 'DATA' : 'Tools'}
                </p>
                <SidebarItem
                  collapsed={collapsed}
                  icon={<GoGraph size={22} />}
                  text="Analytics"
                  link="/analytics"
                />
              </div>
            </Menu>
          </div>

          <div className="pb-4">
            <Menu
              menuItemStyles={{
                button: ({ level, active }) => {
                    return {
                      padding: '10px 20px',
                      borderRadius: '8px',
                      margin: '5px 10px',
                      backgroundColor: active ? '#eff6ff' : 'transparent',
                      color: active ? '#2563eb' : '#374151',
                      '&:hover': {
                        backgroundColor: '#f3f4f6',
                        color: '#1f2937',
                      },
                    };
                  },
              }}
            >
              <SidebarItem
                collapsed={collapsed}
                icon={<CgProfile size={22} />}
                text="Profile"
                link="/profile"
              />
              <div className="p-4 border-t border-gray-200 mt-2">
                <button 
                  onClick={toggleCollapse} 
                  className="w-full flex items-center justify-center gap-4 text-gray-500 hover:text-gray-800"
                >
                  {collapsed ? <BsArrowRightSquare size={22} /> : <BsArrowLeftSquare size={22} />}
                  {!collapsed && <span className="font-medium text-sm">Collapse</span>}
                </button>
              </div>
            </Menu>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};
